import { ErrorHandler, inject, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AppErrorService } from '../services/app-error.service';

/**
 * Captura erros não tratados (incl. falhas de API/banco) e exibe mensagem amigável
 * em vez de tela branca.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly appError = inject(AppErrorService);

  handleError(error: unknown): void {
    if (error instanceof HttpErrorResponse && error.status === 404) {
      console.warn('[GlobalErrorHandler] 404 (recurso não encontrado) — não exibir overlay.', error.url);
      return;
    }
    const err = error instanceof Error ? error : new Error(String(error));
    if (error instanceof HttpErrorResponse) {
      this.appError.setError(error);
    } else {
      this.appError.setError(err);
    }
    console.error('[GlobalErrorHandler]', error);
    setTimeout(() => this.appError.showFallbackElement(), 800);
  }
}
